import React from "react";
import ReactApexChart from "react-apexcharts";
import { IReportMetricsTotal } from "../../../../../@types/reports-metrics.type";
import styles from "./styles.module.scss";

export const BarChart: React.FC<IReportMetricsTotal> = ({
  totalAvailable,
  totalNonScheduled,
  totalScheduledPercentage,
  totalScheduled,
  totalGeneral,
}) => {
  const series = [
    {
      name: "Horas Alocadas",
      data: [totalScheduledPercentage],
    },
    {
      name: "Não Alocadas",
      data: [100 - totalScheduledPercentage],
    },
  ];

  const labels = ["Horas Alocadas", "Não Alocadas"];

  const options = {
    chart: {
      type: "bar",
      height: 100,
      stacked: true,
      stackType: "100%",
      toolbar: {
        show: false,
      },
      fontFamily: "archivo, sans-serif",
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: -150,
            offsetY: -50,
            style: {
              fontSize: "13px",
            },
            formatter: function () {
              return `Total: ${totalGeneral} (${totalAvailable})`;
            },
          },
        },
      },
    },
    stroke: {
      show: false,
      width: 1,
      colors: ["#fff"],
    },
    title: {
      text: "Total de Horas (Capacity)",
      style: {
        color: "#212121",
        fontWeight: 600,
      },
    },
    xaxis: {
      tickAmount: 0,
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
    },
    grid: {
      show: false,
    },
    tooltip: {
      custom: function ({ series, seriesIndex }) {
        const value = series[seriesIndex];
        const label = labels[seriesIndex];

        return `
          <div class='labelCustom' style="flex-direction: row;">
            <strong>${label}:</strong>
            <span>${Math.round(value).toString().replace(".", ",")}%</span>
          </div>
        `;
      },
    },
    fill: {
      opacity: 1,
      colors: ["#008ffb", "#ffae69"],
    },
    dataLabels: {
      style: {
        colors: ["#fff", "#212121"],
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
      fontSize: "13px",
      labels: {
        colors: ["#616161", "#616161"],
      },
      formatter: function (val, { seriesIndex }) {
        return `${val} (${seriesIndex == 0 ? `${totalScheduled}` : `${totalNonScheduled}`
          })`;
      },
    },
  };

  return (
    <div className={styles.mainCard}>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={200}
          width="100%"
        />
      </div>
    </div>
  );
};
